<template>

    <!--================ Head Menu Area =================-->

    <div></div>

    <!--================ //Head Menu Area =================-->

</template>

<script>

    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        },

        data() {
            return {

                gubunPage: "INC ZADMIN TOP"

            };
        },

        methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , default() {

            }

        },

        beforeCreate() {
            // this.$PrintLog(this.gubunPage + " : beforeCreate");
        },

        created() {
            // this.$PrintLog(this.gubunPage + " : created");
        },

        beforeMount() {
            // this.$PrintLog(this.gubunPage + " : beforeMount");
        },

        mounted() {
            this.$PrintLog(this.gubunPage + " : mounted");
            this.default();
        },

        beforeUpdate() {
            // this.$PrintLog(this.gubunPage + " : beforeUpdate");
        },

        updated() {
            // this.$PrintLog(this.gubunPage + " : updated");
        },

        beforeDestroy() {
            // this.$PrintLog(this.gubunPage + " : beforeDestroy");
        },

        destroyed() {
            // this.$PrintLog(this.gubunPage + " : destroyed");
        },
    };
</script>
